import { render, staticRenderFns } from "./PageContainerSkeleton.vue?vue&type=template&id=07269b9e&scoped=true"
import script from "./PageContainerSkeleton.vue?vue&type=script&lang=js"
export * from "./PageContainerSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07269b9e",
  null
  
)

export default component.exports